import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/icon.tsx");
